// in-app-browser.service.ts
import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class InAppBrowserService {
  isIOS(): boolean {
    return /iP(hone|od|ad)/.test(navigator.platform)
      || (navigator.userAgent.includes('Mac') && 'ontouchend' in document);
  }

  isInAppBrowser(): boolean {
    const ua = navigator.userAgent || '';
    const isKnownInApp = /(FBAN|FBAV|Instagram|Line|MicroMessenger|TikTok|GSA)/i.test(ua); // GSA = Google app

    const isSafariViewController =
      ua.includes('Safari') && !ua.includes('CriOS') && !ua.includes('FxiOS') && !(navigator as any).standalone;

    return this.isIOS() && (isKnownInApp || isSafariViewController);
  }
}
